import { ReactNode } from 'react';

import {
  ItemRenderExtensionOptions,
  createItemRenderExtension,
  createItemRenderExtensions,
  useItemRenderExtensions,
} from '@spotify/confidence-core-react';
import {
  ActivityFragment,
  ChangeSetFragment,
} from '@spotify/confidence-graphql';

export interface ActivityChangeOptions {
  activity: ActivityFragment;
  change: ChangeSetFragment['changes'][number];
}

export interface ActivityChangeExtensionOptions
  extends ItemRenderExtensionOptions<ActivityChangeOptions> {
  /** When true, matching items are completely hidden without calling render. */
  suppress?: boolean;
  title?: (
    change: ChangeSetFragment['changes'][number],
    options?: ActivityChangeOptions,
  ) => string;
  titleElement?: (change: ChangeSetFragment['changes'][number]) => ReactNode;
  tag?: (change: ChangeSetFragment['changes'][number]) => {
    tagLabel: string;
    ariaLabel?: string;
  } | null;
  values?: (change: ChangeSetFragment['changes'][number]) => {
    oldValue?: object;
    newValue?: object;
  };
}

export const createActivityChangeExtensions = (id: string) => {
  return createItemRenderExtensions({
    id,
  });
};

export const useActivityChangeExtensions = (
  extensions: ReturnType<typeof createActivityChangeExtensions>,
): ActivityChangeExtensionOptions[] => {
  return useItemRenderExtensions<ActivityChangeExtensionOptions>(extensions);
};

export const createActivityChangeExtension = (
  options: ActivityChangeExtensionOptions,
) => {
  return createItemRenderExtension<ActivityChangeExtensionOptions>(options);
};
